export const groupModulesByType = modules => {
  return modules.reduce((groups, module) => {
    const type = module.moduleType || (module.minY === 0 ? 'lower' : 'upper');
    if (!groups[type]) {
      groups[type] = [];
    }
    groups[type].push(module);
    return groups;
  }, {});
};

export const checkTextureType = (selectedModels, canUseAcrylic) => {
  let textureTypeTemp = 'L,M,Plywood,Plastic,Acrylic MDF L,Acrylic Plastic WPB';

  if (
    selectedModels.some(item => item.userData?.cabinetType?.includes('kitchen'))
  ) {
    textureTypeTemp = 'L,Plywood,Plastic';
  } else {
    textureTypeTemp = 'L,M,Plywood,Plastic';
  }
  // if (
  //   selectedModels.some(
  //     item =>
  //       item.userData?.moduleType?.includes('upper') &&
  //       item.userData?.cabinetType?.includes('kitchen')
  //   )
  // ) {
  //   textureTypeTemp = 'L,Plastic';
  // }
  if (canUseAcrylic) {
    textureTypeTemp += ',Acrylic MDF L,Acrylic Plastic WPB';
  }
  return textureTypeTemp;
};

export const getSupplierFromModules = modules => {
  const suppliers = [];

  const moduleEntries = Array.from(modules.entries());
  moduleEntries.forEach(([item, value]) => {
    let tempTextureFrame = null;
    let tempTextureDoor = null;
    let tempTextureLouveredWall = null;

    if (value?.textures.get('frame')) {
      tempTextureFrame = value?.textures.get('frame');
    }
    if (value?.textures.get('DOOR')) {
      tempTextureDoor = value?.textures.get('DOOR');
    }
    if (
      value?.textures.get('VACH-LAM') ||
      value?.textures.get('VACH-TRON') ||
      value?.textures.get('VACH-GUONG')
    ) {
      tempTextureLouveredWall =
        value?.textures.get('VACH-LAM') ??
        value?.textures.get('VACH-TRON') ??
        value?.textures.get('VACH-GUONG');
    }

    if (
      suppliers.findIndex(
        item =>
          item?.id === tempTextureFrame?.supplier?.id &&
          item?.materialType === tempTextureFrame?.supplier?.materialType
      ) === -1 &&
      tempTextureFrame?.supplier?.id
    ) {
      suppliers.push(tempTextureFrame?.supplier);
    }
    if (
      suppliers.findIndex(
        item =>
          item?.id === tempTextureDoor?.supplier?.id &&
          item?.materialType === tempTextureDoor?.supplier?.materialType
      ) === -1 &&
      tempTextureDoor?.supplier?.id
    ) {
      suppliers.push(tempTextureDoor?.supplier);
    }
    if (
      suppliers.findIndex(
        item =>
          item?.id === tempTextureLouveredWall?.supplier?.id &&
          item?.materialType === tempTextureLouveredWall?.supplier?.materialType
      ) === -1 &&
      tempTextureLouveredWall?.supplier?.id
    ) {
      suppliers.push(tempTextureLouveredWall?.supplier);
    }
  });

  return suppliers;
};

export const getUpperModuleList = modules => {
  const moduleEntries = Array.from(modules.entries());
  const modulesUpper = moduleEntries.filter(([key, module]) =>
    module.moduleType.includes('upper')
  );
  return modulesUpper;
};

export const getCeilingModuleList = modules => {
  const moduleEntries = Array.from(modules.entries());
  const modulesCeiling = moduleEntries.filter(([key, module]) =>
    module.moduleType.includes('ceiling')
  );
  return modulesCeiling;
};
